import mainSiteMixin from "@/mixins/mainSiteMixin";

export default {
    mixins: [mainSiteMixin],
    methods: {
        setSingleBooking(bookingKey, booking) {
            this.$store.commit('booking/setSingleBooking', {booking: booking, key: bookingKey})
        },
        removeRequestedBooking(bookingKey) {
            this.requestedBookings = this.requestedBookings.filter(requestedBooking => requestedBooking !== bookingKey)
            this.deletedBookings = [...this.deletedBookings, bookingKey]
        },
    },
    computed: {
        resources: {
            get() {
                return this.$store.state.booking.siteData.resources
            }
        },
        bookings: {
            get() {
                return this.$store.state.booking.bookingData.bookings
            },
            set(value) {
                this.setBookingProp('bookings', value)
            }
        },
        requestedBookings: {
            get() {
                return this.$store.state.booking.bookingData.requestedBookings
            },
            set(value) {
                this.setBookingProp('requestedBookings', value)
            }
        },
        requestBookingsAsList() {
            if (!this.requestedBookings?.length) return []
            return this.requestedBookings.map(requestedBookingKey => {
                    return this.bookings[requestedBookingKey] ?? null
                }
            ).filter(event => !!event)
        },
        deletedBookings: {
            get() {
                return this.$store.state.booking.bookingData.deletedBookings
            }
            ,
            set(value) {
                this.setBookingProp('deletedBookings', value)
            }
        }
        ,
        requestedBookingCount() {
            return this.bookingData?.requestedBookings?.length
        }
    },
}
